"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralUtil = void 0;
function generalUtil() {
    return {
        b64: {
            encode: function (s) {
                return btoa(s);
            },
            decode: function (s) {
                return atob(s);
            },
        },
    };
}
exports.GeneralUtil = generalUtil();
//# sourceMappingURL=general.js.map